import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_qr_view",
  ref: "qrViewModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"370px !important"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "QR View", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_QRCodeVue3 = _resolveComponent("QRCodeVue3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_QRCodeVue3, {
              width: 300,
              height: 300,
              value: _ctx.url,
              qrOptions: {
                typeNumber: 0,
                mode: 'Byte',
                errorCorrectionLevel: 'H',
              },
              imageOptions: {
                hideBackgroundDots: true,
                imageSize: 0.4,
                margin: 0,
              },
              dotsOptions: {
                type: 'dots',
                color: '#26249a',
                gradient: {
                  type: 'linear',
                  rotation: 0,
                  colorStops: [
                    { offset: 0, color: '#26249a' },
                    { offset: 1, color: '#26249a' },
                  ],
                },
              },
              backgroundOptions: { color: '#ffffff' },
              cornersSquareOptions: { type: 'dot', color: '#000000' },
              cornersDotOptions: { type: undefined, color: '#000000' },
              fileExt: "png",
              download: false,
              myclass: "my-qur",
              imgclass: "img-qr",
              downloadButton: "my-button",
              downloadOptions: { name: 'qr', extension: 'png' }
            }, null, 8, ["value", "imageOptions"])
          ])
        ])
      ])
    ])
  ], 512))
}